import React from "react";
import SearchComponent from "@presto-screen-components/SearchComponent/SearchComponent";

export default function SearchInputComponent(props) {
  return <SearchComponent {...props} />;
}
